import { useOktaAuthnOktaAuth } from '@ssar-app/okta-authn-react';
import { useMemo } from 'react';

export const useIsAuthenticated = () => {
  const oktaAuth = useOktaAuthnOktaAuth();
  const isAuthed = useMemo(
    () => oktaAuth?.authStateManager?.getAuthState()?.isAuthenticated === true,
    [oktaAuth?.authStateManager],
  );
  return isAuthed;
};
